module.exports = __webpack_public_path__ + "img/yilianGl5.4a1ff8b3.png";